/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function getStickyHeaderOffset() {
    var headerSection = document.querySelector(".header-section");
    var siteHeader = document.querySelector("header[data-sticky='true'], #SiteHeader[data-sticky='true']");

    if (!headerSection || !siteHeader) return 0;

    var headerStyle = window.getComputedStyle(headerSection);
    if (headerStyle.position !== "sticky" && headerStyle.position !== "fixed") return 0;

    return Math.ceil(headerSection.getBoundingClientRect().height);
  }

  function getAnchorTarget(hash) {
    if (!hash || hash === "#") return null;

    var id = hash.slice(1);

    try {
      id = decodeURIComponent(id);
    } catch (error) {
      id = hash.slice(1);
    }

    var target = document.getElementById(id);
    if (target) return target;

    try {
      return document.querySelector(hash);
    } catch (error) {
      return null;
    }
  }

  function scrollToAnchor(target, updateHash) {
    var offset = getStickyHeaderOffset() + 16;
    var targetTop = target.getBoundingClientRect().top + window.pageYOffset - offset;
    var behavior = prefersReducedMotion() ? "auto" : "smooth";

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: behavior
    });

    if (updateHash && window.history && window.history.pushState) {
      window.history.pushState(null, "", "#" + encodeURIComponent(target.id));
    }

    if (!target.hasAttribute("tabindex")) {
      target.setAttribute("tabindex", "-1");
    }

    try {
      target.focus({ preventScroll: true });
    } catch (error) {
      target.focus();
    }
  }

  function initSmoothAnchorLinks() {
    document.addEventListener("click", function (event) {
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      if (!event.target.closest) return;

      var link = event.target.closest("a[href*='#']");
      if (!link) return;

      var rawHref = link.getAttribute("href");
      if (!rawHref || rawHref === "#") return;
      if (link.target && link.target !== "_self") return;
      if (link.hasAttribute("download")) return;
      if (link.matches("[data-no-smooth-scroll], [data-drawer], [data-modal]")) return;
      if (typeof link.className === "string" && link.className.indexOf("js-modal-open") !== -1) return;

      var url;

      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;

      var target = getAnchorTarget(url.hash);
      if (!target || !target.id) return;

      event.preventDefault();
      scrollToAnchor(target, true);
    });

    if (window.location.hash) {
      var initialTarget = getAnchorTarget(window.location.hash);
      if (initialTarget) {
        window.setTimeout(function () {
          scrollToAnchor(initialTarget, false);
        }, 80);
      }
    }

    window.addEventListener("hashchange", function () {
      var target = getAnchorTarget(window.location.hash);
      if (!target) return;

      window.setTimeout(function () {
        scrollToAnchor(target, false);
      }, 0);
    });
  }

  function initScrollParallax() {
    var parallaxItems = Array.prototype.slice.call(
      document.querySelectorAll("[data-scroll-parallax], .js-scroll-parallax")
    );

    if (!parallaxItems.length || prefersReducedMotion()) return;

    var ticking = false;

    function updateParallax() {
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      parallaxItems.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewportHeight) return;

        var speed = parseFloat(item.dataset.scrollParallaxSpeed || item.dataset.parallaxSpeed || "0.12");
        var axis = item.dataset.scrollParallaxAxis || item.dataset.parallaxAxis || "y";
        var progress = (viewportHeight / 2 - (rect.top + rect.height / 2)) / viewportHeight;
        var movement = progress * viewportHeight * speed;
        var x = axis === "x" ? movement : 0;
        var y = axis === "x" ? 0 : movement;

        item.style.transform = "translate3d(" + x.toFixed(2) + "px, " + y.toFixed(2) + "px, 0)";
      });

      ticking = false;
    }

    function requestParallaxUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    }

    window.addEventListener("scroll", requestParallaxUpdate, { passive: true });
    window.addEventListener("resize", requestParallaxUpdate);
    updateParallax();
  }

  DOMready(function () {
    initSmoothAnchorLinks();
    initScrollParallax();
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();
